import { PaymentMethodType } from '@nemuru-eng/js-api-client';

import { AbstractPaymentMethod } from '@/components/modules/Application/components/PaymentMethod/_shared/entities/PaymentMethod/AbstractPaymentMethod';
import { SinglePaymentMethod } from '@/components/modules/Application/components/PaymentMethod/_shared/entities/PaymentMethod/SinglePaymentMethod';
import { A2APaymentMethodCardWithWrapper } from '@/components/modules/Application/components/PaymentMethod/A2APayment/components/PaymentMethodCard/A2APaymentMethodCard';
import { AutoLoanPaymentMethodCardWithWrapper } from '@/components/modules/Application/components/PaymentMethod/AutoLoan/components/PaymentMethodCard/AutoLoanPaymentMethodCard';
import { AutoLoanPaymentMethod } from '@/components/modules/Application/components/PaymentMethod/AutoLoan/entities/PaymentMethod/AutoLoanPaymentMethod';
import { B2BLoanPaymentMethod } from '@/components/modules/Application/components/PaymentMethod/B2BLoan/entities/PaymentMethod/B2BLoanPaymentMethod';
import { BnplPaymentMethodCardWithWrapper } from '@/components/modules/Application/components/PaymentMethod/Bnpl/components/PaymentMethodCard/BnplPaymentMethodCard';
import { BnplPaymentMethod } from '@/components/modules/Application/components/PaymentMethod/Bnpl/entities/PaymentMethod/BnplPaymentMethod';
import { CardPaymentMethodCardWithWrapper } from '@/components/modules/Application/components/PaymentMethod/CardPayment/components/PaymentMethodCard/CardPaymentMethodCard';
import { ConsumerLoanPaymentMethodCardWithWrapper } from '@/components/modules/Application/components/PaymentMethod/ConsumerLoan/components/PaymentMethodCard/ConsumerLoanPaymentMethodCard';
import { ConsumerLoanPaymentMethod } from '@/components/modules/Application/components/PaymentMethod/ConsumerLoan/entities/PaymentMethod/ConsumerLoanPaymentMethod';
import { CreditLinePaymentMethodCardWithWrapper } from '@/components/modules/Application/components/PaymentMethod/CreditLine/components/PaymentMethodCard/CreditLinePaymentMethodCard';
import { CreditLinePaymentMethod } from '@/components/modules/Application/components/PaymentMethod/CreditLine/entities/PaymentMethod/CreditLinePaymentMethod';

interface PaymentMethodCardFactoryProps {
  paymentMethodEntity: AbstractPaymentMethod;
}

export const PaymentMethodCardFactory = ({ paymentMethodEntity }: PaymentMethodCardFactoryProps) => {
  // Es importante el orden
  // por ejemplo, las instancias de la clase CreditLinePaymentMethod
  // también lo son de ConsumerLoanPaymentMethod (pues extiende de ella)

  if (paymentMethodEntity instanceof BnplPaymentMethod) {
    return <BnplPaymentMethodCardWithWrapper paymentMethodEntity={paymentMethodEntity} />;
  }

  if (paymentMethodEntity instanceof CreditLinePaymentMethod) {
    return <CreditLinePaymentMethodCardWithWrapper paymentMethodEntity={paymentMethodEntity} />;
  }

  if (paymentMethodEntity instanceof AutoLoanPaymentMethod || paymentMethodEntity instanceof B2BLoanPaymentMethod) {
    return <AutoLoanPaymentMethodCardWithWrapper paymentMethodEntity={paymentMethodEntity} />;
  }

  if (paymentMethodEntity instanceof ConsumerLoanPaymentMethod) {
    return <ConsumerLoanPaymentMethodCardWithWrapper paymentMethodEntity={paymentMethodEntity} />;
  }

  if (
    paymentMethodEntity instanceof SinglePaymentMethod &&
    paymentMethodEntity.paymentMethodType === PaymentMethodType.CARD_PAYMENT
  ) {
    return <CardPaymentMethodCardWithWrapper paymentMethodEntity={paymentMethodEntity} />;
  }

  if (
    paymentMethodEntity instanceof SinglePaymentMethod &&
    paymentMethodEntity.paymentMethodType === PaymentMethodType.A2A_PAYMENT
  ) {
    return <A2APaymentMethodCardWithWrapper paymentMethodEntity={paymentMethodEntity} />;
  }

  return null;
};
